import React, { ReactElement, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { CustomDialog } from "../components/CustomDialog";
import AlignmentTrend from "./AlignmentTrend";
import { useTracking } from "../analytics/useTracking";
import { Category, Action } from "../analytics/Tracking";

export interface AlignmentTrendDialogProps {
    open: boolean;
    roomUrlId: string;
    onClosed: () => void;
}

export function AlignmentTrendDialog(props: AlignmentTrendDialogProps): ReactElement {
    const [open, setOpen] = React.useState(props.open);
    const { track } = useTracking();

    React.useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    // Track when dialog opens
    useEffect(() => {
        if (props.open) {
            track.event(Category.User, Action.AlignmentTrendVisited, props.roomUrlId);
        }
    }, [props.open, props.roomUrlId, track]);

    const handleClosed = () => {
        props.onClosed();
    };

    return (
        <CustomDialog open={open} onClosed={handleClosed} maxWidth="md" fullWidth>
            <Box sx={{ py: 2, width: '100%' }}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                    Team Alignment Trends
                </Typography>
                <AlignmentTrend roomUrlId={props.roomUrlId} />
            </Box>
        </CustomDialog>
    );
}

